import Image from 'next/image'

interface IProps {
  url?: string | null
  className?: string
  alt?: string
}

const CompanyLogo = ({ url, className, alt = '' }: IProps) => (
  <div
    className={`${className} relative rounded-md flex items-center justify-center`}
  >
    {url ? <img src={url} className='max-w-full max-h-full' alt={alt} /> : null}
  </div>
)

export default CompanyLogo
